import axios from "axios";
const BASIC_API = process.env.REACT_APP_BASIC_API + "/AdminAccountManagement";

class AccountService {
    create(requestBody) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}`, 
            requestBody
        , {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    search(filters, page) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/Search`, 
            {
                ...filters,
                "sortOrder": "id",
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": false,
                    "targetPage": page,
                    "showCount": 10
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    getDetails(accountId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.get(`${BASIC_API}/${accountId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    update(accountId, requestBody) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.put(`${BASIC_API}/${accountId}`,
            requestBody
        , {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    delete(companyId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.delete(`${BASIC_API}/${companyId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
}

const NewAccountService = new AccountService();
export default NewAccountService;